<p class="text-xl p-10 text-red">
  Vous n'êtes pas autorisé à accéder à l'Espace Partenaire, merci de prendre contact avec l'administrateur de
  l'application
</p>
